import React from "react";
import QuimicaSvg from "./../../../../Assets/Svg/Quimica.svg";
import { Image } from "react-bootstrap";
import { Animated } from "react-animated-css";
import ParticulasComponent from "./../Particulas/Particulas.component";
import "./Banner.component.scss";

const BannerComponent = () => {
  return (
    <div className="Banner">
      <div className="Banner__Imagen">
        <Animated
          animationIn="bounceInLeft"
          animationOut="fadeOut"
          isVisible={true}
        >
          <h1>¡Bienvenido!</h1>
          <h3>Productos quimicos industriales, venta por mayor y menor</h3>
        </Animated>
      </div>
      <div className="Banner__Texto animate__bounce">
        <Animated
          animationIn="fadeInRight"
          animationOut="fadeOut"
          isVisible={true}
        >
          <ParticulasComponent>
            <Image src={QuimicaSvg} fluid />
          </ParticulasComponent>
        </Animated>
      </div>
    </div>
  );
};

export default BannerComponent;
